import {IconName} from '../../libs/shared/ui/src/components/icon/icon';
import {ContactSourcesEnum} from '../models/api/contactModel';

export function getChannelIconName(contactSource: ContactSourcesEnum): IconName {
  switch (contactSource) {
    case ContactSourcesEnum.LAYER:
    case ContactSourcesEnum.FACEBOOK:
    case ContactSourcesEnum.INTERCOM:
    case ContactSourcesEnum.SMOOCH:
    case ContactSourcesEnum.TWITTER:
    case ContactSourcesEnum.TWITTER_DM:
    case ContactSourcesEnum.FRONT_CHAT:
      return 'channelChatSmall';

    case ContactSourcesEnum.CUSTOM:
      return 'channelCustomSmall';

    case ContactSourcesEnum.GOOGLE_PLAY:
      return 'channelGooglePlaySmall';

    case ContactSourcesEnum.PHONE:
      return 'channelCallSmall';

    default:
      return 'channelEmailSmall';
  }
}
